import React, { useState, useEffect } from "react";
import Loader from "../../../Common/Loader/loader";
import { useLocation } from "react-router-dom";
import { GetZone } from "../../../Apis/organizationApi";
import CustomDataTable from "../../../Common/ReportTable/ReportTable";
import { useNavigate } from "react-router-dom";
import { AllVehicleTypeDetails } from "../../../Apis/vehicleApi";
import { Formik, Form, Field } from "formik";
import ExcelJS from "exceljs";
import { Modal } from "react-bootstrap";
import { formattedDate, getCurrentDateTime1, getCurrentISTDate } from "../../../Common/helper/helpar";

const ViewinnerVehicleReport = () => {
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const { data, formatDate, shiftName } = location.state || {};
  const date = localStorage.getItem("date");
  const navigate = useNavigate();
  const [scvList, setScvList] = useState([]);
  const [zoneName, setZoneName] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [showImageModal, setShowImageModal] = useState(false);
  const [vehicleTypeData, setVehicleTypeData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const zoneData = await GetZone();
        const vehicleTypeData = await AllVehicleTypeDetails();
        const zoneIdFromLocalStorage = localStorage.getItem("zoneId");
        const zoneNamesDictionary = {};
        const vehicleTypeNamesDictionary = {};

        zoneData.forEach((zone) => {
          zoneNamesDictionary[zone.zoneId] = zone.zoneName;
        });

        vehicleTypeData.forEach((vehicleType) => {
          vehicleTypeNamesDictionary[vehicleType.vehicleTypeId] = vehicleType.vehicleTypeName;
        });

        setVehicleTypeData(vehicleTypeNamesDictionary);

        const zoneName = zoneNamesDictionary[zoneIdFromLocalStorage];
        setZoneName(zoneName);

        // Apply default filter on load
        const defaultValues = getDefaultFilterFields();
        searchReportedAtVehicleHandler(defaultValues);
      } catch (error) {
        console.error("Error fetching data:", error);
        setScvList(data || []); // Fallback to unfiltered data
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const modifiedData = data?.map((item) => ({
    ...item,
    circle: item.circleName,
    NoOfVehiclesAlloted: item.allotedVehicleRCV,
    NoOfVehiclesReported: item.beforeImageUrl,
    afterImage: item.afterImageUrl,
  }));

  const scvCircleReportColumns = [
    {
      name: "S.No",
      width: "6%",
      selector: (row) => row["sno"],
      sortable: true,
      format: (row, rowIndex) => rowIndex + 1,
      width: "70px",
    },
    {
      name: "Zone",
      width: "8%",
      selector: (row) => <span>{row["zoneName"] || "N/A"}</span>,
      sortable: true,
      width: "120px",
    },
    {
      name: "Circle",
      width: "8%",
      selector: (row) => <span>{row["circleName"] || "N/A"}</span>,
      sortable: true,
      width: "120px",
    },
    {
      name: <>Vehicle Number</>,
      width: "15%",
      selector: (row) => <span>{row["vehicleNumber"] || "N/A"}</span>,
      sortable: true,
      width: "120px",
    },
    {
      name: <>Vehicle Type</>,
      selector: (row) => row["vehicleTypeName"],
      cell: (row) => <span>{row["vehicleTypeName"] || "N/A"}</span>,
      sortable: true,
    },
    {
      name: <>Owner Type</>,
      selector: (row) => row["ownerTypeName"],
      cell: (row) => <span>{row["ownerTypeName"] || "N/A"}</span>,
      sortable: true,
    },
    {
      name: <>Vehicle Capacity</>,
      selector: (row) => row["vehicleCapacityName"],
      cell: (row) => <span>{row["vehicleCapacityName"] || "N/A"}</span>,
      sortable: true,
    },
    {
      name: <>Mobile Number</>,
      selector: (row) => <span>{row["mobileNumber"] || "N/A"}</span>,
      sortable: true,
      width: "120px",
    },
    {
      name: <>Driver Name</>,
      selector: (row) => <span>{row["driverName"] || "N/A"}</span>,
      sortable: true,
    },
    {
      name: <>No.of Helpers</>,
      selector: (row) => <span>{row["numberOfHelpers"]}</span>,
      sortable: true,
      width: "120px",
    },
    {
      name: <>Deployment Date</>,
      selector: (row) => <span>{row["deploymentDateFormatted"] || "N/A"}</span>,
      sortable: true,
      width: "130px",
    },
     {
      name: <>Latitude</>,
      selector: (row) => <span>{row["scannedLatitude"] || "N/A"}</span>,
      sortable: true,
      width: "130px",
    },
     {
      name: <>Longitude</>,
      selector: (row) => <span>{row["scannedLongitude"] || "N/A"}</span>,
      sortable: true,
      width: "130px",
    },
    {
      name: "Deployment Image",
      width: "200px",
      cell: (row) => {
        if (row["vehicleImageUrl"]) {
          return (
            <img
              src={row["vehicleImageUrl"]}
              alt="Vehicle"
              style={{ width: "100px", height: "50px", objectFit: "cover", borderRadius: "10px", cursor: "pointer" }}
              onClick={() => handleImageClick(row.vehicleImageUrl)}
            />
          );
        } else {
          return <span style={{ color: "blue" }}>No image</span>;
        }
      },
      sortable: true,
    },
  ];

  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
    setShowImageModal(true);
  };

  const handleClose = () => {
    setShowImageModal(false);
    setSelectedImage(null);
  };

  const handleBackClick = () => {
    navigate(-1);
  };

  const downloadAsExcel = async () => {
    const currentDate = new Date();
    const formattedDates = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const cumulativeHeadingReport = `Circle Wise No of Vehicle Reported SCVs at Circle Report on ${formatDate ? formattedDate(formatDate) : getCurrentISTDate()} - ${shiftName} (at ${getCurrentDateTime1()})`;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Zones");

    const boldFont = { bold: true };

    const downloadDateTime = `Reported on: ${formattedDates} ${formattedTime}`;
    const dateTimeRow = worksheet.addRow(["", "", downloadDateTime, "", ""]);
    worksheet.mergeCells(1, 3, 1, 5);
    dateTimeRow.getCell(3).font = boldFont;
    dateTimeRow.getCell(3).alignment = { horizontal: "center" };
    dateTimeRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      if (colNumber >= 3 && colNumber <= 5) {
        cell.font = boldFont;
        cell.alignment = { horizontal: "center" };
      }
    });

    const cumulativeHeadingRow = worksheet.addRow(["", "", cumulativeHeadingReport, "", ""]);
    worksheet.mergeCells(2, 3, 2, 7);
    cumulativeHeadingRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      if (colNumber >= 3 && colNumber <= 9) {
        cell.font = boldFont;
        cell.alignment = { horizontal: "center" };
      }
    });

    worksheet.addRow([""]);

    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Zone",
      "Circle",
      "Vehicle Number",
      "Vehicle Type",
      "Owner Type",
      "Vehicle Capacity",
      "Mobile Number",
      "Driver Name",
      "No of Helpers",
      "Deployment Date",
      "Latitude",
      "Longitude",
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" };
      if (colNumber >= 1 && colNumber <= 17) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" },
        };
      }
    });

    scvList.forEach((item, index) => {
      worksheet.addRow([
        index + 1,
        item.zoneName ?? "N/A",
        item.circleName ?? "N/A",
        item.vehicleNumber ?? "N/A",
        item.vehicleTypeName ?? "N/A",
        item.ownerTypeName ?? "N/A",
        item.vehicleCapacityName ?? "N/A",
        item.mobileNumber ?? "N/A",
        item.driverName ?? "N/A",
        item.numberOfHelpers ?? "N/A",
        item.deploymentDate ?? "N/A",
        item.scannedLatitude ?? "N/A",
        item.scannedLongitude ?? "N/A",
      ]).eachCell({ includeEmpty: true }, (cell, colNumber) => {
        if (colNumber >= 1 && colNumber <= 14) {
          cell.alignment = { horizontal: "left" };
        } else {
          cell.alignment = { horizontal: "center" };
        }
      });
    });

    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 40 },
      { width: 40 },
      { width: 40 },
      { width: 40 },
      { width: 20 },
      { width: 40 },
      { width: 40 },
      { width: 20 },
    ];

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "SCVsInnerVehicleReport.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };

  // Set default filter values based on formatDate
  const getDefaultFilterFields = () => {
    // Use formatDate if provided, else current date
    const baseDate = formatDate ? new Date(formatDate) : new Date();
    // Handle invalid formatDate
    if (isNaN(baseDate.getTime())) {
      baseDate = new Date();
    }
    const fromDate = new Date(baseDate.getFullYear(), baseDate.getMonth(), baseDate.getDate(), 0, 0); // Start of day
    const now = new Date(); // Current time
    const toDate = new Date(baseDate.getFullYear(), baseDate.getMonth(), baseDate.getDate(), now.getHours(), now.getMinutes()); // Current time on baseDate

    const formatDateTime = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${year}-${month}-${day}T${hours}:${minutes}`;
    };

    return {
      searchCircle: "",
      searchVehicleNumber: "",
      searchDriverName: "",
      searchFromDate: formatDateTime(fromDate), // e.g., "2025-05-20T00:00"
      searchToDate: formatDateTime(toDate), // e.g., "2025-05-20T12:59"
    };
  };

  const filterFields = getDefaultFilterFields();

  const parseDeploymentDate = (dateString) => {
    if (!dateString || dateString === "N/A") return null;
    // Parse deploymentDateFormatted in "DD-MM-YYYY HH:mm:ss" format
    // Example: "20-05-2025 07:10:18"
    const [datePart, timePart] = dateString.split(" ");
    if (!datePart || !timePart) return null;
    const [day, month, year] = datePart.split("-").map(Number);
    const [hour, minute] = timePart.split(":").map(Number);
    const date = new Date(year, month - 1, day, hour, minute);
    return isNaN(date.getTime()) ? null : date;
  };

  const searchReportedAtVehicleHandler = (values) => {
    const termCircle = values.searchCircle ? values.searchCircle.toLowerCase() : "";
    const termVehicle = values.searchVehicleNumber ? values.searchVehicleNumber.toLowerCase() : "";
    const termDriverName = values.searchDriverName ? values.searchDriverName.toLowerCase() : "";
    const termFromDate = values.searchFromDate ? new Date(values.searchFromDate) : null;
    const termToDate = values.searchToDate ? new Date(values.searchToDate) : null;

    const filteredData = (data || []).filter((item) => {
      const circleName = item?.circleName ? item.circleName.toLowerCase() : "";
      const vehicle = item?.vehicleNumber ? item.vehicleNumber.toLowerCase() : "";
      const driverName = item?.driverName ? item.driverName.toLowerCase() : "";
      const deploymentDate = parseDeploymentDate(item?.deploymentDateFormatted);

      console.log("deploymentDateFormatted:", item?.deploymentDateFormatted);
      console.log("parsed deploymentDate:", deploymentDate);
      console.log("termFromDate:", termFromDate);
      console.log("termToDate:", termToDate);

      const matchesCircle = !termCircle || circleName.includes(termCircle);
      const matchesVehicle = !termVehicle || vehicle.includes(termVehicle);
      const matchesDriverName = !termDriverName || driverName.includes(termDriverName);
      const matchesDate =
        !deploymentDate ||
        (!termFromDate && !termToDate) ||
        (termFromDate && !termToDate && deploymentDate >= termFromDate) ||
        (!termFromDate && termToDate && deploymentDate <= termToDate) ||
        (termFromDate && termToDate && deploymentDate >= termFromDate && deploymentDate <= termToDate);

      return matchesCircle && matchesVehicle && matchesDriverName 
      // && matchesDate;
    });

    setScvList(filteredData);
  };

  const handleReset = () => {
    const defaultValues = getDefaultFilterFields();
    searchReportedAtVehicleHandler(defaultValues); // Apply default filter
    const form = document.getElementById("filterForm");
    form.reset();
    form.dispatchEvent(new Event("reset"));
  };

  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="page-header"></div>
            <div className="card">
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-center mb-3 mt-3">
                  <Formik initialValues={filterFields}>
                    {({ handleChange, values }) => (
                      <Form id="filterForm">
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-group">
                              <Field
                                name="searchCircle"
                                placeholder="Search Circle"
                                type="text"
                                className="form-control bg-white"
                                onInput={(e) => {
                                  handleChange(e);
                                  searchReportedAtVehicleHandler({ ...values, searchCircle: e.target.value });
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <Field
                                name="searchVehicleNumber"
                                placeholder="Search Vehicle Number"
                                type="text"
                                className="form-control bg-white"
                                onInput={(e) => {
                                  handleChange(e);
                                  searchReportedAtVehicleHandler({ ...values, searchVehicleNumber: e.target.value });
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <Field
                                name="searchDriverName"
                                placeholder="Search Driver Name"
                                type="text"
                                className="form-control bg-white"
                                onInput={(e) => {
                                  handleChange(e);
                                  searchReportedAtVehicleHandler({ ...values, searchDriverName: e.target.value });
                                }}
                              />
                            </div>
                          </div>
                          {/* <div className="col-md-2">
                            <div className="form-group">
                              <Field
                                name="searchFromDate"
                                placeholder="From Date and Time"
                                type="datetime-local"
                                className="form-control bg-white"
                                onInput={(e) => {
                                  handleChange(e);
                                  searchReportedAtVehicleHandler({ ...values, searchFromDate: e.target.value });
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="form-group">
                              <Field
                                name="searchToDate"
                                placeholder="To Date and Time"
                                type="datetime-local"
                                className="form-control bg-white"
                                onInput={(e) => {
                                  handleChange(e);
                                  searchReportedAtVehicleHandler({ ...values, searchToDate: e.target.value });
                                }}
                              />
                            </div>
                          </div> */}
                        </div>
                      </Form>
                    )}
                  </Formik>

                  <div className="d-flex">
                    <button className="btn btn-secondary me-2" onClick={handleBackClick}>
                      Back
                    </button>
                    <button className="btn btn-excel" onClick={downloadAsExcel}>
                      <i className="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                    </button>
                  </div>
                </div>
                <div className="top-header">
                  <span>
                    {data?.zoneName} Circle Wise No of Vehicle Reported SCVs at Circle Report as on {formatDate ? formattedDate(formatDate) : getCurrentISTDate()} - {shiftName} (at {getCurrentDateTime1()})
                  </span>
                </div>

                <CustomDataTable data={scvList} columns={scvCircleReportColumns} />
              </div>
            </div>
          </div>
        </div>
      </div>
      {isLoading && <Loader />}
      <Modal show={showImageModal} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Image Full Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <img
            src={selectedImage}
            alt="Full vehicle"
            style={{ width: "100%", height: "400px", borderRadius: "5px", objectFit: "contain" }}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ViewinnerVehicleReport;